'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import Image from 'next/image';
import { Button } from './ui/button';
import { ArrowRight, Zap, Palette, Code2 } from 'lucide-react';

// Loyihalar ma'lumotlari (MUTLAQ YO'LLAR BILAN YANGILANDI)
const projectData = {
  fashion: {
    img: '/luxe.png',
  },
  education: {
    img: '/learnify.png', // XATO TO'G'IRLANDI
  },
  saas: {
    img: '/cloudflow.png',
  },
  agency: {
    img: '/apex.png',
  },
};

export function Projects() {
  const t = useTranslations('projects');

  const metrics = [
    {
      icon: Zap,
      title: t('metrics.speed.title'),
      desc: t('metrics.speed.desc'),
    },
    {
      icon: Palette,
      title: t('metrics.design.title'),
      desc: t('metrics.design.desc'),
    },
    {
      icon: Code2,
      title: t('metrics.code.title'),
      desc: t('metrics.code.desc'),
    },
  ];

  const projects = t.raw('items');

  return (
    <section id="projects" className="py-20 md:py-28 bg-white dark:bg-black">
      <div className="container mx-auto px-6">
        {/* Marketing Sarlavhasi */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto text-center mb-16 md:mb-20"
        >
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-black dark:text-white mb-4">
            {t('title')}
          </h2>
          <p className="text-md text-gray-500 dark:text-gray-400">
            {t('subtitle')}
          </p>
        </motion.div>

        {/* Marketing Trio Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20 md:mb-24">
          {metrics.map((metric, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ delay: 0.1 + i * 0.1 }}
              className="bg-gray-50 dark:bg-zinc-900/50 p-6 rounded-lg border border-gray-200 dark:border-zinc-800"
            >
              <metric.icon className="w-7 h-7 mb-4 text-black dark:text-white" />
              <h3 className="font-bold text-lg text-black dark:text-white mb-2">{metric.title}</h3>
              <p className="text-sm text-gray-500 dark:text-gray-400">{metric.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Loyihalar ro'yxati */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16">
          {Object.keys(projectData).map((key, i) => {
            const projectInfo = projectData[key as keyof typeof projectData];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-120px' }}
                transition={{ delay: 0.1 + i * 0.15 }}
              >
                <div className="group block mb-4 overflow-hidden rounded-lg">
                  <Image
                    src={projectInfo.img}
                    alt={projects[key].title}
                    width={1600}
                    height={1200}
                    className="w-full h-auto object-cover transform transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3 className="text-xl font-bold text-black dark:text-white">{projects[key].title}</h3>
                <div className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2 mt-1">
                  <span>{projects[key].badge}</span>
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Barcha ishlarni ko'rish tugmasi */}
        <div className="text-center mt-20">
          <Button asChild size="lg" className="group">
            <Link href="/projects">
              {t('view_all')}
              <ArrowRight className="w-4 h-4 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
